<template>
  <div class="con">
    <img src="/static/images/img21.png" alt="">
    <img src="/static/images/img22.png" alt="">
    <img src="/static/images/img23.png" alt="">
  </div>

</template>

<script>
export default {
  name: 'familyimgDetaile',
  data () {
    return {

    }
  },
  mounted(){

  },
  methods:{}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .con img{
    display: block;
    width: 100%;
    height: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/familyimgDetaile.vue